import { render, staticRenderFns } from "./cloud-video-modal.vue?vue&type=template&id=4b0d6e93&scoped=true"
import script from "./cloud-video-modal.vue?vue&type=script&lang=js"
export * from "./cloud-video-modal.vue?vue&type=script&lang=js"
import style0 from "./cloud-video-modal.vue?vue&type=style&index=0&id=4b0d6e93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d6e93",
  null
  
)

export default component.exports